import { render } from "./assetView.vue?vue&type=template&id=a58cfcde"
import script from "./assetView.vue?vue&type=script&lang=js"
export * from "./assetView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__